export default __webpack_public_path__ + "static/media/O-059.26d4040f.png";